import { NoticeGroupsUIProvider } from "./NoticeGroupsUIContext";
import { NoticeGroupsCard } from "./NoticeGroupsCard";

export function NoticeGroupsPage({ history }) {
  const noticeGroupsUIEvents = {
    openNewNoticeGroupPage: () => {
      history.push("/duyuru-gruplari/ekle");
    },
    openEditNoticeGroupPage: (id) => {
      history.push(`/duyuru-gruplari/duzenle/${id}`);
    },
  };
  
  return (
    <NoticeGroupsUIProvider noticeGroupsUIEvents={noticeGroupsUIEvents}>
      <NoticeGroupsCard />
    </NoticeGroupsUIProvider>
 );
}